module.exports = __webpack_public_path__ + "img/box-1-ua.d7f9b7aa.png";